import i18next from "i18next";
import authentication from "../models/authentication";
import { mapUser } from "../../helpers/user";

export const types = {
  CHECK: "CHECK",
  AUTHENTICATION_REQUESTED: "LOGIN_REQUESTED",
  AUTHENTICATION_FAILED: "LOGIN_FAILED",
  AUTHENTICATION_SUCCEDDED: "LOGIN_SUCCEDDED",
  CHANGE_SELECTED_PROJECT: "CHANGE_SELECTED_PROJECT",
  AUTHENTICATION_REGISTER_REQUESTED: "REGISTER_REQUESTED",
  REGISTRATION_FAILED: "REGISTRATION_FAILED",
  LOGOUT_REQUESTED: "LOGOUT_REQUESTED",
  LOGOUT_FAILED: "LOGOUT_FAILED",
  LOGOUT_SUCCEDDED: "LOGOUT_SUCCEDDED",
  VERIFICATION_REQUEST: "VERIFICATION_REQUESTED",
  VERIFICATION_SUCCEDDED: "VERIFICATION_SUCCEDDED",
  VERIFICATION_FAILED: "VERIFICATION_FAILED",
  REGISTRATION_DATA_REQUESTED: "REGISTRATION_DATA_REQUESTED",
  REGISTRATION_DATA_SUCCEDDED: "REGISTRATION_DATA_SUCCEDDED",
  REGISTRATION_DATA_FAILED: "REGISTRATION_DATA_FAILED",
  REGISTRATION_OPTIONS_REQUESTED: "REGISTRATION_OPTIONS_REQUESTED",
  REGISTRATION_OPTIONS_SUCCEDDED: "REGISTRATION_OPTIONS_SUCCEDDED",
  REGISTRATION_OPTIONS_FAILED: "REGISTRATION_OPTIONS_FAILED",
  EXIT_IMPERSONTAION_REQUESTED: "EXIT_IMPERSONTAION_REQUESTED",
  EXIT_IMPERSONATION_FAILED: "EXIT_IMPERSONATION_FAILED",
  RESET_PASSWORD_REQUEST: "RESET_PASSWORD_REQUEST",
  RESET_PASSWORD_REQUEST_SUCCEDDED: "RESET_PASSWORD_REQUEST_SUCCEDDED",
  RESET_PASSWORD_REQUEST_FAILED: "RESET_PASSWORD_REQUEST_FAILED",
  RESET_PASSWORD: "RESET_PASSWORD",
  RESET_PASSWORD_SUCCEDDED: "RESET_PASSWORD_SUCCEDDED",
  RESET_PASSWORD_FAILED: "RESET_PASSWORD_FAILED",
  UPDATE_LANGUAGE_REQUESTED: "UPDATE_LANGUAGE_REQUESTED",
  UPDATE_LANGUAGE_SUCCEDDED: "UPDATE_LANGUAGE_SUCCEDDED",
  UPDATE_LANGUAGE_FAILED: "UPDATE_LANGUAGE_FAILED",
  RESEND_VERIFICATION_REQUESTED: "RESEND_VERIFICATION_REQUESTED",
  RESEND_VERIFICATION_SUCCEDDED: "RESEND_VERIFICATION_SUCCEDDED",
  RESEND_VERIFICATION_FAILED: "RESEND_VERIFICATION_FAILED",
  INVITED_USER_REQUESTED: "INVITED_USER_REQUESTED",
  INVITED_USER_SUCCEDDED: "INVITED_USER_SUCCEDDED",
  INVITED_USER_FAILED: "INVITED_USER_FAILED",
  INVITE_USER_REQUESTED: "INVITE_USER_REQUESTED",
  REMOVE_USER_REQUESTED: "REMOVE_USER_REQUESTED",
  EDIT_USER_REQUESTED: "EDIT_USER_REQUESTED",
  RESEND_INVITE_USER_REQUESTED: "RESEND_INVITE_USER_REQUESTED",
  INVITE_USER_SUCCEDDED: "INVITE_USER_SUCCEDDED",
  INVITE_USER_FAILED: "INVITE_USER_FAILED",
  CONFIRM_INVITE_REQUESTED: "CONFIRM_INVITE_REQUESTED",
  CONFIRM_INVITE_SUCCEDDED: "CONFIRM_INVITE_SUCCEDDED",
  CONFIRM_INVITE_FAILED: "CONFIRM_INVITE_FAILED",
  USER_INVITATION_REQUESTED: "USER_INVITATION_REQUESTED",
  USER_INVITATION_SUCCEDDED: "USER_INVITATON_SUCCEDDED",
  USER_INVITATION_FAILED: "USER_INVITATION_FAILED",
  GET_USER_OPTIONS: 'GET_USER_OPTIONS',
  SET_USER_OPTIONS: 'SET_USER_OPTIONS',
  DEMO_LOGIN: "DEMO_LOGIN",
  DEMO_LOGIN_SUCCEDDED: "DEMO_LOGIN_SUCCEDDED",
  DEMO_LOGIN_FAILED: "DEMO_LOGIN_FAILED",
  DEMO_SIGNUP: "DEMO_SIGNUP",
  DEMO_SIGNUP_SUCCEDDED: "DEMO_SIGNUP_SUCCEDDED",
  DEMO_SIGNUP_FAILED: "DEMO_SIGNUP_FAILED",
  SET_SOURCE_ID: "SET_SOURCE_ID",
  CHANGE_SELECTED_PROJECT_AND_SOURCE_ID: 'CHANGE_SELECTED_PROJECT_AND_SOURCE_ID',
  UPDATE_SETTINGS: 'UPDATE_SETTINGS',
  UPDATE_USER: 'UPDATE_USER',
};

export const actions = {
  getUserOptions: (language) => {
    return { type: types.GET_USER_OPTIONS, value: language };
  },

  check: (pathname, callback = () => {}, mod) => {
    return { type: types.CHECK, pathname, callback, mod };
  },

  updateUser: (user) => {
    return { type: types.UPDATE_USER, value: user };
  },

  UpdateSettings: (payload) => {
    return { type: types.UPDATE_SETTINGS, value: payload };
  },

  changeSourceId: (value) => {
    return { type: types.SET_SOURCE_ID, value };
  },

  login: (value) => {
    return { type: types.AUTHENTICATION_REQUESTED, value };
  },

  logout: (callback) => {
    return { type: types.LOGOUT_REQUESTED, callback };
  },

  register: (value) => {
    return { type: types.AUTHENTICATION_REGISTER_REQUESTED, value };
  },

  verify: (value) => {
    return { type: types.VERIFICATION_REQUEST, value };
  },

  getRegistrationData: value => {
    return { type: types.REGISTRATION_DATA_REQUESTED, value };
  },

  getRegistrationOptions: value => {
    return { type: types.REGISTRATION_OPTIONS_REQUESTED, value };
  },

  exitImpersonation: () => {
    return { type: types.EXIT_IMPERSONTAION_REQUESTED };
  },

  requestResetPassword: (value) => {
    return { type: types.RESET_PASSWORD_REQUEST, value };
  },

  resetPassword: (value) => {
    return { type: types.RESET_PASSWORD, value };
  },

  updateLanguage: (value) => {
    return { type: types.UPDATE_LANGUAGE_REQUESTED, value };
  },

  resendVerification: () => {
    return { type: types.RESEND_VERIFICATION_REQUESTED };
  },

  getInvitedUsers: (callback) => {
    return { type: types.INVITED_USER_REQUESTED, value: { callback } };
  },

  inviteUser: (value, callback = () => { }) => {
    return { type: types.INVITE_USER_REQUESTED, value, callback };
  },

  removeUser: (value, callback = () => { }) => {
    return { type: types.REMOVE_USER_REQUESTED, value, callback };
  },

  editUser: (value, callback = () => { }) => {
    return { type: types.EDIT_USER_REQUESTED, value, callback };
  },

  resendInvite: (value, callback = () => { }) => {
    return { type: types.RESEND_INVITE_USER_REQUESTED, value, callback };
  },

  confirmInvitation: (value, callback = () => { }, code) => {
    return { type: types.CONFIRM_INVITE_REQUESTED, value, callback, code };
  },

  getUserFromInvitation: (value, callback = () => { }) => {
    return { type: types.USER_INVITATION_REQUESTED, value, callback };
  },

  changeSelectedProject: (value, dashboardView) => {
    return { type: types.CHANGE_SELECTED_PROJECT, value, dashboardView };
  },

  changeSelectedProjectAndSourceId: (selectedProject, sourceId, dashboardView) => {
    return {
      type: types.CHANGE_SELECTED_PROJECT_AND_SOURCE_ID,
      selectedProject,
      sourceId,
      dashboardView,
    };
  },

  demoLogin: (token, callback = () => { }) => {
    return { type: types.DEMO_LOGIN, value: token, callback };
  },

  demoSignup: (payload, callback = () => { }) => {
    return { type: types.DEMO_SIGNUP, value: payload, callback };
  },
};

const reducer = (state = authentication, action) => {
  switch (action.type) {
    case types.SET_USER_OPTIONS:
      return {
        ...state,
        options: action.value,
      }
    case types.UPDATE_USER:
      return {
        ...state,
        user: {
          ...state.user,
          ...action.value,
        }
      }
    case types.UPDATE_SETTINGS:
      return {
        ...state,
        user: {
          ...state.user,
          settings: action.value,
        }
      }
    // sourceId
    case types.SET_SOURCE_ID:
      return {
        ...state,
        sourceId: action.value,
      };
    // login
    case types.AUTHENTICATION_REQUESTED:
    case types.USER_INVITATION_REQUESTED:
    case types.DEMO_LOGIN:
      return {
        ...state,
        loggingIn: true,
      };

    case types.AUTHENTICATION_SUCCEDDED:
    case types.DEMO_LOGIN_SUCCEDDED:
      return {
        ...state,
        authenticated: true,
        user: {
          ...(mapUser(action.value)),
        },
        error: false,
        checking: false,
        verifying: false,
      };

    case types.AUTHENTICATION_FAILED:
    case types.DEMO_LOGIN_FAILED:
      return {
        ...state,
        error: true,
        loggingIn: false,
        checking: false,
        registerLoading: false,
        errors: action.value || null,
      };

    // register
    case types.AUTHENTICATION_REGISTER_REQUESTED:
      return {
        ...state,
        registerLoading: true,
        verifying: false,
      };
    case types.REGISTRATION_FAILED:
      return {
        ...state,
        error: true,
        loggingIn: false,
        checking: false,
        registerLoading: false,
        registerErrors: action.value || null,
      };
    // logout
    case types.LOGOUT_REQUESTED:
      return {
        ...state,
        loggingOut: true,
        verifying: false,
      };

    case types.LOGOUT_FAILED:
      return {
        ...state,
        user: null,
        loggingOut: false,
        error: true,
        verifying: false,
      };

    case types.VERIFICATION_REQUEST:
    case types.RESEND_VERIFICATION_REQUESTED:
      return {
        ...state,
        verifying: true,
      };

    case types.VERIFICATION_SUCCEDDED:
    case types.RESEND_VERIFICATION_SUCCEDDED:
      return {
        ...state,
        authenticated: true,
        user: {
          // emailVerified: true,
          ...action.value,
        },
        verifying: false,
        verified: true,
      };

    case types.VERIFICATION_FAILED:
    case types.RESEND_VERIFICATION_FAILED:
      return {
        ...state,
        verifying: false,
        verified: false,
        verificationFailed: true,
        errors: action.value || null,
      };

    case types.REGISTRATION_DATA_SUCCEDDED:
      return {
        ...state,
        registrationData: action.value
      };

    case types.REGISTRATION_DATA_FAILED:
      return {
        ...state,
        errors: action.value || null
      }

    case types.REGISTRATION_OPTIONS_SUCCEDDED:
      return {
        ...state,
        registrationOptions: action.value
      };

    case types.REGISTRATION_OPTIONS_FAILED:
      return {
        ...state,
        errors: action.value || null
      }
    case types.RESET_PASSWORD_REQUEST:
    case types.RESET_PASSWORD:
      return {
        ...state,
        submitting: true,
      }
    case types.RESET_PASSWORD_REQUEST_SUCCEDDED:
      return {
        ...state,
        resetRequestSuccedded: true,
        resetRequestError: null,
        resetRequestStatu: null,
        submitting: false,
      }
    case types.RESET_PASSWORD_REQUEST_FAILED:
      const requestPassError = action.value;
      let resetRequestError = requestPassError.data && requestPassError.data.message ? requestPassError.data.message : requestPassError.message;
      if (requestPassError.status === 404) {
        resetRequestError = i18next.t('userResetPasswordNotFound')
      }
      return {
        ...state,
        resetRequestError,
        resetRequestStatus: requestPassError.status,
        submitting: false,
      }

    case types.UPDATE_LANGUAGE_SUCCEDDED:
      const user = state.user

      if (user) {
        user.language = action.value || 'en';

        return {
          ...state,
          user
        }
      } else {
        return state;
      }

    case types.UPDATE_LANGUAGE_FAILED:
      return {
        ...state,
        errors: action.value || null,
      }

    case types.INVITED_USER_SUCCEDDED:
      Object.assign(state, { invitedUsers: action.value });
      return {
        ...state,
      }

    case types.INVITED_USER_FAILED:
      return {
        invitedUsers: [],
        errors: action.value || null,
        ...state,
      }

    case types.INVITE_USER_SUCCEDDED:
      return {
        ...state,
      }

    case types.INVITE_USER_FAILED:
      return {
        ...state,
        errors: action.value || null,
      }

    case types.USER_INVITATION_SUCCEDDED:
      return {
        ...state,
        user: action.value,
        loggingIn: true,
        invitationSuccess: true,
      }

    case types.USER_INVITATION_FAILED:
      return {
        ...state,
        errors: action.value || null,
        loggingIn: false,
        invitationSuccess: false,
      }

    case types.CONFIRM_INVITE_REQUESTED:
      return {
        ...state,
        errors: action.value || null,
      }
    case types.CHANGE_SELECTED_PROJECT:
      return {
        ...state,
        selectedProject: action.value || null,
        dashboardView: action.dashboardView || undefined,
      }
    case types.CHANGE_SELECTED_PROJECT_AND_SOURCE_ID:
      return {
        ...state,
        selectedProject: action.selectedProject,
        sourceId: action.sourceId,
        dashboardView: action.dashboardView || undefined,
      }

    default:
      return state;
  }
};

export default reducer;
